import Column from "@/Components/Grid/Column";
import Container from "@/Components/Grid/Container";
import Row from "@/Components/Grid/Row";
import { Head, Link } from "@inertiajs/react";
import { useEffect, useState } from "react";

import useIsServer from "@/Hooks/useIsServer";

import HeroImage from '@static/test-cage-bg.jpg?format=webp&quality=85&imagetools';
import CageQuestionnaire from "./CageQuestionnaire";
import PatientLayout from "@/Layouts/PatientLayout";

const Cage = () => {
    return (
        <PatientLayout>
            <Head title="Test CAGE" />

            <section id="hero-article" className='-mt-24 maxMd:-mt-20 relative min-h-screen maxMd:h-full mb-14 maxMd:mb-0'>
                <div className='object-cover bg-no-repeat bg-center bg-cover h-screen maxMd:h-full' style={{ backgroundImage: `url(${HeroImage})` }}>
                    <div className="absolute inset-0 w-full h-full bg-gradientArticle"></div>
                    <Container className='relative z-10 h-full'>
                        <Row className='items-center h-full'>
                            <Column className='h-full flex flex-col min-h-[calc(100vh_-_304px)]'>
                                <Row className="my-auto justify-center">
                                    <Column xl={10} className="text-center">
                                        <h1 className='h1 text-arcticMist font-semibold tracking-[1.2px] mb-2'>Kwestionariusz CAGE</h1>
                                    </Column>
                                </Row>
                            </Column>
                        </Row>
                    </Container>
                </div>
                <Container className="-mt-[8%] relative z-20 maxMd:mt-0">
                    <Row className="justify-center">
                        <Column xl={10}>
                            <div className="bg-gradientBackground xl:p-28 md:p-16 maxMd:px-0 maxMd:pt-16 maxMd:-mx-4 max:max-w-[1920px] max:mx-auto">
                                <Container>
                                    <Row>
                                        <Column>
                                            <h2 className="text-arcticMist h4 mb-6 font-semibold">Kwestionariusz cage</h2>
                                            <p className="text-arcticMist text-body tracking-[0.27px] mb-12">Jest to krótki zestaw pytań stosowany do wstępnej oceny ryzyka nadużywania alkoholu. Narzędzie jest powszechnie używane w kontekście badań przesiewowych, zarówno przez specjalistów, jak i w ramach samooceny. CAGE składa się z czterech prostych pytań, które mają na celu zidentyfikowanie potencjalnych problemów związanych z alkoholem.<sup>1,2,3</sup></p>
                                            <p className="text-arcticMist text-body tracking-[0.27px] mb-12">Ważne jest, aby pamiętać, że kwestionariusz CAGE nie jest narzędziem diagnostycznym. Oznacza to, że uzyskane wyniki nie stanowią diagnozy i nie zastępują profesjonalnej oceny zdrowotnej. Jeśli masz jakiekolwiek obawy dotyczące swojego zdrowia, powinieneś skonsultować się z lekarzem lup specjalistą.</p>
                                            <CageQuestionnaire/>
                                        </Column>
                                    </Row>
                                </Container>
                            </div>
                        </Column>
                    </Row>
                </Container>
            </section>
        </PatientLayout>
    )
}

export default Cage;